
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est la technique utilisée?`}</em></p>
    <p>{`Les protéines recombinantes, une technique plus traditionnelle que celles
choisies par d’autres firmes dans cette course contre le Covid-19. Avec les
vaccins à ARN messager, un message est envoyé à nos cellules pour qu’elles
produisent une protéine du virus. Dans le vaccin de Novavax, cette protéine
(spike) est créée en laboratoire (dans une cellule d’insecte, ce qui permet une
production plus rapide et plus efficace qu’avec une cellule de mammifère). Elle
est ensuite injectée dans notre corps pour qu’il génère des anticorps. Pour
stimuler notre système immunitaire, on a recours à des adjuvants.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;